export default class TokenRefreshService {
    constructor(AuthService, SchemaService, firebase, $interval, $window) {
        'ngInject';
        this.as = AuthService;
        this.ss = SchemaService;
        this.fb = firebase;
        this.$interval = $interval;
        this.$window = $window;
        this.refreshTokenTime = 0;
        this.tokenRefreshInterval = null;
        this.template = null;
        this.initialize();
    }

    async initialize() {
        this.fb.auth().onAuthStateChanged(async user => {
            if (user) {
              const [provider, realm] = await Promise.all([this.as.getProviderSettings(), this.as.realm()]);
              this.template = { template: { realm } };
              this.refreshTokenTime = provider.refreshTokenTime;
              this.startTokenRefreshInterval();
            }
            else {
                this.refreshTokenTime = 0;
                this.template = null;
                this.stopTokenRefreshInterval();
            }
          });
    }

    startTokenRefreshInterval() {
        this.stopTokenRefreshInterval();
        if (this.refreshTokenTime > 0) {
            this.tokenRefreshInterval =
                this.$interval(() => {
                    this.ss.validConnection(this.template)
                        .then((r) => { })
                        .catch((e) => { this.stopTokenRefreshInterval(); this.$window.location.reload(); });
                    }, this.refreshTokenTime);
        }
    }

    stopTokenRefreshInterval() {
        if (this.tokenRefreshInterval) {
            this.$interval.cancel(this.tokenRefreshInterval);
        }
    }
}